
import React from 'react'
import { Col } from 'react-bootstrap'

import './HSGFooter.css'


const HSGFooter = () => {

        return (
                <Col  className="hsg-footer-container">                    
                    <p className="text-muted text-center hsg-footer-content"><small>Powered by HealthSetGo. All rights Reserved</small></p>                    
                </Col>                
        )

}

export default HSGFooter


// WEBPACK FOOTER //
// ./src/Containers/HSGFooterContainer/Component/HSGFooter.js